//抖音助手
export const tiktokHelperRouter = [
  {
    path: '/service/tiktokHelper/pro',
    name: 'TiktokProductSync',
    component: () => import('@/views/service/serviceProvider/tiktokHelper/TiktokProductSync'),
    meta: {
      title: '商品绑定',
      keepAlive: false
    }
  },
  {
    path: '/service/tiktokHelper/order',
    name: 'TiktokOrderList',
    component: () => import('@/views/service/serviceProvider/tiktokHelper/TiktokOrderList'),
    meta: {
      title: '订单直连',
      keepAlive: false
    }
  },
  {
    path: '/service/tiktokHelper/account',
    name: 'TiktokStores',
    component: () => import('@/views/service/serviceProvider/tiktokHelper/TiktokStores'),
    meta: {
      title: '关联店铺',
      keepAlive: false
    }
  }
]